import axios from "axios";
import { Toast } from "antd-mobile";
// axios.defaults.baseURL = "http://192.168.0.150:8080/";
// axios.defaults.baseURL = "http://120.77.216.30/sdt/";
// axios.defaults.baseURL = "http://www.tietonggroup.com/sd";
// axios.defaults.baseURL = "http://120.77.151.17/sd";

axios.defaults.baseURL = window.CONFIG_URL.baseURL;
axios.defaults.withCredentials = true;
//超时时间为60s
axios.defaults.timeout = 30000;
//响应拦截器

axios.interceptors.request.use(
    config => {
        const token =
            sessionStorage.getItem("loginMsg") &&
            JSON.parse(sessionStorage.getItem("loginMsg")).token;
        const accessToken = sessionStorage.getItem("pc-access-token");
        const webSession = sessionStorage.getItem("manager-web-session");
        config.headers["pc-access-token"] = accessToken;
        config.headers["manager-web-session"] = webSession;
        config.params = {
            token: token,
            ...config.params,
        };
        // Toast.loading("加载中...", 10);
        return config;
    },
    error => {
        return Promise.reject(error);
    },
);

axios.interceptors.response.use(
    response => {
        document.getElementById("root").scrollTop = 0;
        if (
            response &&
            response.data &&
            response.data.data &&
            response.data.data.hasOwnProperty &&
            response.data.data.resultList
        ) {
            response.data.data.resultList = response.data.data.resultList || [];
        }
        if (response.data.status == 200 && response.data) {

        } else {
            if (response.data.status == 397 || response.data.status == 403) {
                //登录超时
                sessionStorage.removeItem("loginMsg");
                sessionStorage.removeItem("manager-web-session");
                sessionStorage.removeItem("pc-access-token");
                sessionStorage.removeItem("userListPage");
                window.location.reload();
            }
        }
        Toast.hide();
        return response.data;
    },
    error => {
        console.log(error);
        Toast.hide();
        Toast.info("操作失败", 1);
    },
);
export default axios;
